"use client";
import {
  scroll_shadow_default
} from "./chunk-NCVCYSZZ.mjs";
import {
  useScrollShadow
} from "./chunk-NGBOO6ON.mjs";
export {
  scroll_shadow_default as ScrollShadow,
  useScrollShadow
};
